<template>
    <div class="single-filter multi-select-filter search-filter-dropdown">
        <div class="dropdown dropdown-with-animation chips-dropdown">
            <a href="#"
               class="btn btn-filter px-3"
               :class="{'applied': value.length}"
               data-toggle="dropdown"
               @click="startNavigation"
               aria-haspopup="true"
               aria-expanded="false">
                {{ label ? label : $t('multi_select') }}
                <span class="clear-icon" v-if="value.length" @click.prevent="clearAndApply">
                        <app-icon :name="'x'"/>
                </span>
            </a>
            <div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
                <div class="btn-dropdown-close d-sm-none">
                        <span class="title">
                            {{ label ? label : $t('multi_select') }}
                        </span>
                    <span class="back float-right" @click.prevent="closeDropDown">
                            <app-icon name="x"/>
                        </span>
                </div>
                <div class="form-group form-group-with-search">
                        <span class="form-control-feedback">
                            <app-icon name="search"/>
                        </span>

                    <input type="text"
                           ref="searchInput"
                           :class="'form-control'"
                           v-bind:value="searchValue"
                           @input="getSearchValue($event)"
                           :placeholder="$t('search')"
                           @keydown.down="navigateDown"
                           @keydown.up="navigateUp"
                           @keydown.enter.prevent="enterSelectedValue"
                           :autofocus="startNavigation">
                </div>

                <div class="dropdown-divider my-0"/>
                <div class="dropdown-search-result-wrapper custom-scrollbar" ref="optionList">
                    <a v-for="(option, index) in options"
                       :key="index"
                       class="dropdown-item"
                       :class="{'active':index==activeIndex, 'selected': isChipSelected(option.id), 'disabled':option.disabled}"
                       href="#" @click.prevent="addChips(option)">
                        {{ option[listValueField] }}
                        <span class="check-sign float-right">
                            <app-icon :name="'check'" class="menu-icon"/>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {FilterMixin} from './mixins/FilterMixin';
import {NavigationMixin} from "../input/mixin/NavigationMixin";
import CoreLibrary from "../../helpers/CoreLibrary";
import FilterAction from "./FilterAction";
import {includeInList} from "../../helpers/string/StringHelper";

export default {
    name: "MultiSearchSelectFilter",
    mixins: [FilterMixin, NavigationMixin],
    extends: CoreLibrary,
    components: {FilterAction},
    data() {
        return {
            searchValue: "",
            value: [],
            list: [],
        }
    },
    props: {
        label: {
            type: String,
            default: ''
        },
        listValueField: {
            type: String,
            default: 'value'
        },
        url: {
            type: String,
            default: ''
        },
    },
    computed: {
        options() {
            this.activeIndex = -1;
            if (!_.isEmpty(this.searchValue)) {
                return this.list.filter(option => {
                    return option[this.listValueField].toLowerCase().includes(this.searchValue.toLowerCase());
                });
            } else return this.list;
        }
    },
    mounted() {
        this.$hub.$on('clearAllFilter-' + this.tableId, () => {
            this.clearAndInitiate();
        });
    },
    watch: {
        active: {
            handler: function (active) {
                if(!this.isUndefined(active)) {
                    this.value = typeof active === 'string' ? active.split(',') : active;
                    this.isApply = true;
                }
            },
            immediate: true
        }
    },
    methods: {
        enterSelectedValue() {
            this.options.filter((item, index) => {
                if (index == this.activeIndex) {
                    this.addChips(item.toString())
                }
            });
            this.endNavigation();
        },
        getSearchValue($event) {
            this.axiosGet(this.url, {
                params: {
                    search: $event.target.value,
                }
            })
            .then(response => {
                if (typeof response.data != 'undefined' && typeof response.data.data != 'undefined') {
                    this.list = response.data.data.map(league => {
                        return {
                            id: league.id,
                            value: league.name,
                        }
                    });
                }
            });
            this.searchValue = $event.target.value;
        },
        isChipSelected(value) {
            return this.value.includes(value.toString());
        },
        addChips(chip) {
            if (this.value.includes(chip.id.toString())) {
                let selectedTimeIndex = this.value.indexOf(chip.id.toString());
                this.value.splice(selectedTimeIndex, 1);
            } else
                this.value.push(chip.id.toString());
            this.changed();
            this.searchValue = '';
        },
        deleteChips(event, index) {
            event.stopPropagation();
            this.value.splice(index, 1);
            this.changed();
        },
        changed() {
            this.returnValue(this.value.toString());
        },
        clear() {
            this.closeDropDown();
            this.value = [];
        },
        clearAndInitiate() {
            this.clear();
        },
        clearAndApply(e) {
            e.stopPropagation();
            this.clear();
            this.returnValue(this.value.toString());
        },
    }
}
</script>
